import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import FormCheckbox from '../../../../../library/form/components/FormCheckbox';
import ProdIOListQtyCell, { ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdIOOOmrViewRow = (props) => {
    const { formObject, rowKey } = props;

        return (
            <ul className="uiDPEditLine uiTableRowLevel1">
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemId" }} />
                </li>
                <li className="uiColumnLeft uiColumn350">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyReturned1" param2="qtyReturned2" format="a" />
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "resUnitCost" }}/>
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "processUnitCost" }}/>
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "ohUnitCost" }}/>
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "totalUnitCost" }}/>
                </li>
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "totalCost" }}/>
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "showAIC" }} >
                    <FormCheckbox formObject={formObject} rowKey={rowKey} 
                            action={{ InputType: "onOff", actionId: "refresh",
                            actionParam: { actionType: "changeIsAIC" },
                            paramName: "isAIC" }} />
                </FormWrapper>
                <li className="uiColumnLeft uiColumn90">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "actionInvType" }} />
                </li>
                <li className="uiColumnLeft uiColumn90">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        useVal={1}
                        action={{ paramName: "actionInvId", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
            </ul>
        )
}

export default ProdIOOOmrViewRow
